

export default function Liquor() {
      return (
    <div className="bg-white py-16 px-6 md:px-12 space-y-12">
            <h2 className="flex justify-self-center text-3xl md:text-4xl font-semibold text-gray-900">
            Liquor Store
          </h2>
      {/* Section 1 - Wine & Spirits */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Text Left */}
        <div>
          <h2 className="text-2xl text-newblue mb-4">
            FINE WINES & SPIRITS
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed">
            Our liquor department offers an unmatched collection of fine wines,
            premium spirits, and artisanal liqueurs from around the world. From
            bold reds and crisp whites to small-batch bourbons and smooth
            tequilas, our shelves are stocked with selections that bring flavor
            and craftsmanship to every occasion.
          </p>
        </div>

        {/* Image Right */}
        <div>
          <img
            src="/assets/liquor.jpg"
            alt="Wine"
            className="w-full h-80 object-cover rounded-2xl shadow-md"
          />
        </div>
      </div>

      {/* Section 2 - Craft Beer */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Image Left */}
        <div>
          <img
            src="https://media.istockphoto.com/id/816174634/photo/alcoholic-drinks.jpg?s=612x612&w=0&k=20&c=EFrdSDU-WBtOsUtpCdWRsf5q-882pIaSSVeI94lY0Iw="
            alt="Beer selection"
            className="w-full h-80 object-cover rounded-2xl shadow-md"
          />
        </div>

        {/* Text Right */}
        <div>
          <h2 className="text-2xl text-newblue mb-4">
            CRAFT BEERS & BREWS
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed">
            Explore our rotating selection of local and imported craft beers,
            featuring seasonal releases, IPAs, lagers, stouts, and ciders. Each
            brew is carefully chosen to highlight quality, creativity, and
            flavor diversity — perfect for beer lovers and casual drinkers
            alike.
          </p>

        </div>
      </div>
    </div>
  );
}